"use client";
import {useRef, useState} from 'react';
import {Info, X} from 'lucide-react';

type Guidance = {examples:{label:string;value:string}[];note:string};
const formats:Record<string,Guidance>={
 Facebook:{examples:[
  {label:'Username',value:'your.name'},
  {label:'Profile link',value:'facebook.com/your.name'},
  {label:'Numbered profile link',value:'facebook.com/profile.php?id=123456789'},
 ],note:'An @ before your username is optional. Use your profile page, not a post.'},
 Instagram:{examples:[
  {label:'Username',value:'@your.name'},
  {label:'Profile link',value:'instagram.com/your.name'},
 ],note:'The @ is optional. Use your profile link, not a post or Reel.'},
 TikTok:{examples:[
  {label:'Username',value:'@yourname'},
  {label:'Profile link',value:'tiktok.com/@yourname'},
 ],note:'The @ is optional when entering a username. Use your profile link, not a video.'},
 LinkedIn:{examples:[
  {label:'Personal profile',value:'linkedin.com/in/your-name'},
  {label:'Company page',value:'linkedin.com/company/company-name'},
 ],note:'Paste the profile or company-page link, not a post or your display name.'},
 X:{examples:[
  {label:'Username',value:'@yourname'},
  {label:'Profile link',value:'x.com/yourname'},
 ],note:'The @ is optional. Links beginning with twitter.com also work. Use a profile, not a post.'},
 IMDb:{examples:[
  {label:'Name page',value:'imdb.com/name/nm1234567'},
 ],note:'Use your name page, not a film or TV title page.'},
 'Public URL':{examples:[
  {label:'Website or agency page',value:'https://example.com/about'},
  {label:'Online resume',value:'https://example.com/resume.pdf'},
 ],note:'Paste a public link to a page or document about your work.'},
};

export function ProfileAccountFormatTip({platform,prefix,label}:{platform:string;prefix:string;label:string}){
 const [open,setOpen]=useState(false);
 const trigger=useRef<HTMLButtonElement>(null);
 const guidance=formats[platform]??formats['Public URL'];
 const title=platform==='Public URL'?'Public URL examples':platform+' formats';
 function close(){setOpen(false);trigger.current?.focus();}
 return <div className="pc-account-label" onKeyDown={e=>{if(open&&e.key==='Escape'){e.preventDefault();e.stopPropagation();close();}}}>
  <label htmlFor={prefix+'-account'}>{label}</label>
  <button ref={trigger} type="button" className="pc-format-trigger" aria-label={title} aria-expanded={open} aria-controls={prefix+'-format-tip'} onClick={()=>setOpen(!open)}><Info size={17} aria-hidden="true"/></button>
  {open&&<div id={prefix+'-format-tip'} className="pc-format-tip" role="region" aria-labelledby={prefix+'-format-title'}>
   <div className="pc-format-tip-heading"><strong id={prefix+'-format-title'}>{title}</strong><button type="button" aria-label="Close format tip" onClick={close}><X size={17} aria-hidden="true"/></button></div>
   <dl>{guidance.examples.map(example=><div key={example.label}><dt>{example.label}</dt><dd><code>{example.value}</code></dd></div>)}</dl>
   <p>{guidance.note}</p>
  </div>}
 </div>;
}
